import { ASP_QUICK_RESULT_PACKAGE_SCOPE } from "../components/quickResult/quickResultProviders";

export const prefetchAspQuickResult = ({
  fetchAspPotentialProviders,
  fetchAspQuickResultSummary,
  companyStore,
  matchScoreWeights,
}) =>
  Promise.all([
    fetchAspPotentialProviders(companyStore, matchScoreWeights),
    fetchAspQuickResultSummary(companyStore, matchScoreWeights, {
      aspQuickResultPackageScope:
        ASP_QUICK_RESULT_PACKAGE_SCOPE.ENTREPRENEUR_AND_SMALL_OFFICE,
    }),
  ]);
